module.exports = __webpack_public_path__ + "static/media/MORENA_FM.bbd80878.png";